export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="flex items-center justify-center h-[44px] bg-[#333333]">
      <span className="text-white text-[8px]">© {year} LIMO [リーモ] |  くらしとお金の経済メディア</span>
    </footer>
  )
}